// extracted by mini-css-extract-plugin
export default {"session-timer":"diVVK","sessionTimer":"diVVK"};